import React from 'react';

/**
 * Mobile Opponent Stats (O:, S:, C:) Component
 * Positioned at top-right, below the drone zone
 */
export const MobileOpponentStats = ({
  opponent
}) => {
  return (
    <div className="opponent-stats-counters-mobile" style={{ 
      position: "absolute", 
      right: "5px", 
      top: "30px", 
      zIndex: 1000,
      display: 'flex', 
      gap: "8px",
      fontSize: "9px",
      fontWeight: 'bold',
      color: 'white',
      transform: "scale(0.8)",
      transformOrigin: "top right"
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
        <span style={{ color: '#e24a4a' }}>O:</span>
        <span>{opponent.hand?.length || 0}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
        <span style={{ color: '#e24a4a' }}>S:</span>
        <span>{opponent.deck?.length ?? opponent.strategy?.orders?.reduce((sum, order) => sum + (order.count || 1), 0) ?? 0}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
        <span style={{ color: '#e24a4a' }}>C:</span>
        <span>{opponent.completedOrders?.length || 0}</span>
      </div>
    </div>
  );
};

export default MobileOpponentStats;

